export default __webpack_public_path__ + "static/media/farmersShop.4eca8bfc.webp";